import React from 'react';
// import PropTypes from 'prop-types';

import { Box, Grid, Stack, Typography } from '@mui/material';
import TestimonialCard from './ReviewSection';

export default function CommonWarrantySection() {
  const visitData = [
    {
      icon: '/assets/images/Product/five.png',
      year: '5 Years',
      title: <>Warranty</>,
      miniTitle: 'On Motors',
      description:
        'Our curtain motors come with a 5-year warranty, ensuring reliable performance and long-term protection. You enjoy seamless control and we’ve got your investment covered.',
    },
    {
      icon: '/assets/images/Product/one.png',
      year: '1 Year  ',
      title: <>Free Service</>,
      miniTitle: 'On Curtains & Blinds',
      description:
        'We stand by our quality. That’s why every Zeal installation includes 1 full year of free service. No surprise charges, no extra maintenance fees — just lasting performance and peace of mind. Because real quality shouldn’t come with recurring costs.',
    },
  ];
  const steps = [
    {
      icon: '/assets/images/Product/icon1.png',
      label: (
        <>
          Schedule FREE <br />
          Home Visit
        </>
      ),
    },
    {
      icon: '/assets/images/Product/icon2.png',
      label: (
        <>
          Visit With <br />
          Curtain Fabrics
        </>
      ),
    },
    {
      icon: '/assets/images/Product/icon3.png',
      label: (
        <>
          Measure, Consult
          <br />
          Estimate
        </>
      ),
    },
  ];
  // eslint-disable-next-line react/no-unstable-nested-components
  const DotSeparator = () => (
    <Stack
      className="dote"
      direction="row"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      sx={{ px: 1, ml: '0 !important', mt: '-42px !important' }}
    >
      {[...Array(3)].map((_, idx) => (
        <Box
          key={idx}
          sx={{
            width: idx === 1 ? 6 : 4,
            height: idx === 1 ? 6 : 4,
            bgcolor: idx === 1 ? '#8A2E2F' : '#ED2629',
            borderRadius: '50%',
          }}
        />
      ))}
    </Stack>
  );
  return (
    <Box my={10}>
      <Stack direction="row">
        <Stack width="50%" justifyContent="center">
          <Box width="70%">
            <TestimonialCard
              image="/assets/images/Home/mobile/reviewImageLeft.webp"
              quote="Zeal’s thermal curtains cut the heat—and my energy bill. Didn’t know curtains could make this much difference. Zeal Just did it."
              name="Salim A. Naser"
              rating={5}
              position="left"
            />
          </Box>
        </Stack>
        <Stack width="50%" gap={2} justifyContent="center">
          <Box
            component="img"
            src="/assets/images/Product/common1.webp"
            alt="Section Visual"
            sx={{
              width: { xs: '100%', md: '100%' },
              borderRadius: 3,
              boxShadow: 3,
            }}
          />
        </Stack>
      </Stack>
      <Box sx={{ p: 2, my: 14 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" spacing={3}>
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <Stack alignItems="center" spacing={1} textAlign="center" sx={{ ml: '0px !important' }}>
                <Box
                  component="img"
                  src={step.icon}
                  alt="Expert Visit"
                  sx={{
                    width: '100%',
                    maxWidth: '59px',
                    height: '57px',
                  }}
                />
                <Typography
                  variant="caption"
                  className="merri-weather-text-bold"
                  sx={{
                    backgroundImage: 'linear-gradient(180deg, #ED2629, #7D2F2F)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {step.label}
                </Typography>
              </Stack>
              {index < steps.length - 1 && <DotSeparator />}
            </React.Fragment>
          ))}
        </Stack>
      </Box>
      <Stack direction="row">
        <Stack width="50%" gap={2} justifyContent="center">
          <Box
            component="img"
            src="/assets/images/Product/common1.webp"
            alt="Section Visual"
            sx={{
              width: { xs: '100%', md: '100%' },
              borderRadius: 3,
              boxShadow: 3,
            }}
          />
        </Stack>
        <Stack width="50%" alignItems="flex-end" justifyContent="center">
          <Box width="70%">
            <TestimonialCard
              image="/assets/images/Home/mobile/reviewImageRight.webp"
              quote="Zeal curtains truly transformed my room — cooler in the day, cozy at night, and total control over light and privacy."
              name="Annie Alex"
              rating={5}
              position="right"
              gapOption="gapOption"
            />
          </Box>
        </Stack>
      </Stack>
      <Grid container spacing={4}>
        {visitData?.map((item, index) => (
          <Grid
            item
            xs={12}
            md={6}
            key={index}
            sx={{
              // borderRight: index === 0 ? '1px solid #e5e5e5' : 'none',
              margin: 'auto',
              mt: 17,
              mb: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Stack direction="column" spacing={2} maxWidth={'430px'}>
              <Stack direction="row" spacing={2.5}>
                <Box width={80} minWidth={80}>
                  <img src={item.icon} alt={item.title} style={{ width: '100%' }} />
                </Box>
                <Box>
                  <Typography
                    fontSize={28}
                    fontWeight="bold"
                    className="merri-weather-text-bold"
                    lineHeight={1.2}
                    color="#E30613"
                    sx={{
                      backgroundImage: 'linear-gradient(to bottom, #ED2629, #7D2F2F)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {item.year}
                    <br />
                    {item.title}
                  </Typography>

                  <Typography
                    className="merri-weather-text-bold"
                    fontSize={20}
                    fontWeight="bold"
                    lineHeight={1.2}
                    color="#7D2F2F"
                  >
                    {item.miniTitle}
                  </Typography>
                  <Box>
                    <Typography className="merri-weather-text-lighter" variant="body2" color="#1E1E1E" mt={1}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
CommonWarrantySection.propTypes = {};
